import { Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

const typeMap = {
  error: {
    bgColor: 'bg-red-500',
    textColor: 'text-white',
  },
  success: {
    bgColor: 'bg-green-300',
    textColor: 'text-black',
  },
  warning: {
    bgColor: 'bg-yellow-300',
    textColor: 'text-black',
  },
  info: {
    bgColor: 'bg-white',
    textColor: 'text-black',
  },
};

export function ToastMessage({ id, message, show, onDismiss, type = 'info' }) {
  const { bgColor, textColor } = typeMap[type] || typeMap.info;

  return (
    <Transition
      key={id}
      show={show}
    >
      <div
        className={clsx(
          'pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0',
          bgColor,
        )}
      >
        <div className="p-4">
          <div className="flex items-center">
            <div className="flex w-0 flex-1 justify-between">
              <p className={clsx('w-0 flex-1 text-sm font-medium', textColor)}>{message}</p>
              {/* <button
                type="button"
                className="ml-3 shrink-0 rounded-md text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                Undo
              </button> */}
            </div>
            <div className="ml-4 flex shrink-0">
              <button
                type="button"
                onClick={() => onDismiss(id)}
                className={clsx(
                  'inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:bg-zinc-950/5 p-1',
                  textColor,
                )}
              >
                <span className="sr-only">Close</span>
                <XMarkIcon
                  aria-hidden="true"
                  className="size-5"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
}
